import { render, staticRenderFns } from "./lagerScanning.vue?vue&type=template&id=1203952f&"
import script from "./lagerScanning.vue?vue&type=script&lang=js&"
export * from "./lagerScanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports